import { useState } from 'react';
import { authenticatedFetch } from '@/services/auth/authenticatedFetch.js';

function useDocxRequest() {
    const [docxFile, setDocxFile] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fileName, setFileName] = useState(null);

    const translateTemplateToApiFormat = (template, languageForTemplate, anonymous, templateName) => {
        console.log("sendDocxRequest, template = ", template, languageForTemplate);

        return {
            templateTitle: template.templateTitle || "",
            language: languageForTemplate.toUpperCase(),
            spokenLanguageUuids: template.spokenLanguages?.map(lang => lang.uuid) || [],
            titleUuid: template.titles?.[0]?.uuid || null,
            descriptionUuid: template.descriptions?.[0]?.uuid || null,
            experienceUuids: template.experiences?.map(exp => exp.uuid) || [],
            educationUuids: template.educations?.map(edu => edu.uuid) || [],
            projectUuids: template.projects?.map(project => project.uuid) || [],
            certificationUuids: template.certifications?.map(cert => cert.uuid) || [],
            mappedSkillUuids: template.mappedSkills?.map(skill => skill.uuid) || [],
            anonymous,
            personUuid: template.personUuid,
            templateName: templateName || "default_template"
        };
    };

    const requestDOCX = async (template, languageForTemplate, anonymous, templateName) => {
        const apiUrl = `${window.ENV.BACKEND_URL}/api/secured/admin/prospect/export/docx`;
        const translatedTemplate = template && translateTemplateToApiFormat(template, languageForTemplate, anonymous, templateName);
        console.log("sendDocxRequest, Template traduit à envoyer :", translatedTemplate);

        setLoading(true);
        try {
            const response = await authenticatedFetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(translatedTemplate),
            }, { retryOnUnauthorized: true });

            const contentDisposition = response.headers.get('Content-Disposition');
            console.log("Content-Disposition", contentDisposition);
            console.log("response", response);

            if (!response.ok) {
                const dataError = await response.json();
                throw new Error(`HTTP error! Status: ${response.status}. Details: ${dataError?.detail}. Title: ${dataError?.title}`);
            }

            // Récupère le fichier DOCX en tant que blob
            const blob = await response.blob();
            console.log("blob: ", blob);

            // Récupère le nom de fichier du DOCX
            let fileName = 'unknown.docx';
            if (contentDisposition) {
                const match = contentDisposition.match(/filename=(.+)/);
                console.log("match", match, contentDisposition);
                if (match?.length > 1) {
                    fileName = match[1];
                }
            }
            setFileName(fileName);

            const docxUrl = URL.createObjectURL(blob); // Crée une URL temporaire pour le DOCX
            setDocxFile(docxUrl); // Stocke l'URL temporaire du DOCX dans docxFile

        } catch (err) {
            console.error("sendDocxRequest, Erreur lors de la requête :", err);
            setError(err);
        } finally {
            setLoading(false);
            console.log("sendDocxRequest, Requête terminée");
        }
    };

    return { requestDOCX, docxFile, loading, error, fileName };
}

export default useDocxRequest;
